import {
  REGISTRATION_STATUS,
  registrationText,
  PROCESSING_PATH,
} from './constants';
import { VehicleRegistrationTrackingDescription } from './RegistrationTrackingDescription';

export const getContentText = (
  registrationStatus: any,
  hasMissingDocuments: boolean,
  isDealerInState: boolean
) => {
  const {
    status,
    isSelfRegistered,
    hasTrackingInformation,
    state,
    hasTransferTag,
    trackingInformation,
    methodOfSubmission,
    processingPath,
  } = registrationStatus;

  switch (status) {
    case REGISTRATION_STATUS.WITHIN_7DMBG:
      if (state === 'AR') {
        return registrationText.WITHIN_7DMBG.arkansas;
      }
      if (isSelfRegistered) {
        return registrationText.WITHIN_7DMBG.selfRegistered;
      }
      if (processingPath === PROCESSING_PATH.TITLE_ONLY) {
        return registrationText.WITHIN_7DMBG.titleOnly;
      }
      return registrationText.WITHIN_7DMBG.default;

    case REGISTRATION_STATUS.READY_TO_WORK:
      if (state === 'AR') {
        return registrationText.READY_TO_WORK.arkansas;
      }
      if (isSelfRegistered) {
        return registrationText.READY_TO_WORK.selfRegistered;
      }
      if (processingPath === PROCESSING_PATH.TITLE_ONLY) {
        return registrationText.READY_TO_WORK.titleOnly;
      }
      return registrationText.READY_TO_WORK.default;

    case REGISTRATION_STATUS.DELAYED:
      if (state === 'AR') {
        return registrationText.DELAYED.arkansas;
      }
      if (hasMissingDocuments) {
        return registrationText.DELAYED.default;
      }
      return registrationText.READY_TO_WORK.default;

    case REGISTRATION_STATUS.SUBMITTED:
      if (processingPath === PROCESSING_PATH.TITLE_ONLY) {
        return registrationText.SUBMITTED.titleOnly;
      }
      return registrationText.SUBMITTED.default;

    case REGISTRATION_STATUS.SUBMITTED_TITLE_ONLY:
      if (state === 'AR') {
        return registrationText.SUBMITTED_TITLE_ONLY.arkansas;
      }
      if (state === 'CO' && methodOfSubmission === 'VITU') {
        return registrationText.SUBMITTED_TITLE_ONLY.colorado_vitu;
      }
      if (state === 'NV') {
        if (isDealerInState) {
          return registrationText.SUBMITTED_TITLE_ONLY.nevada_instate;
        }
        return registrationText.SUBMITTED_TITLE_ONLY.nevada_outofstate;
      }
      return registrationText.SUBMITTED_TITLE_ONLY.default;

    case REGISTRATION_STATUS.REJECTED:
      if (state === 'AR') {
        return registrationText.REJECTED.arkansas;
      }
      if (hasMissingDocuments) {
        return registrationText.REJECTED.default;
      }
      return registrationText.SUBMITTED.default;

    case REGISTRATION_STATUS.COMPLETED:
      if (isSelfRegistered) {
        return registrationText.COMPLETED.selfRegistered;
      }
      if (state === 'GA') {
        return registrationText.COMPLETED.georgia;
      }
      if (state === 'CO' && methodOfSubmission === 'VITU') {
        return registrationText.COMPLETED.colorado_vitu;
      }
      if (hasTransferTag) {
        return registrationText.COMPLETED.hasTransferTag;
      }
      if (hasTrackingInformation) {
        return VehicleRegistrationTrackingDescription(
          trackingInformation.trackingId
        );
      }
      if (processingPath === PROCESSING_PATH.TITLE_ONLY) {
        return registrationText.COMPLETED.titleOnly;
      }
      if (processingPath === PROCESSING_PATH.EARLY_REGISTRATION) {
        return registrationText.COMPLETED.earlyRegistration;
      }
      return registrationText.COMPLETED.default;

    case REGISTRATION_STATUS.PARTIAL_RECEIVED:
      return registrationText.PARTIAL_REJECTED_RECEIVED.default;

    case REGISTRATION_STATUS.REJECTED_RECEIVED:
      if (state === 'AR') {
        return registrationText.PARTIAL_REJECTED_RECEIVED.arkansas;
      }
      return registrationText.PARTIAL_REJECTED_RECEIVED.default;

    case REGISTRATION_STATUS.PARTIAL_RESOLVED:
      return registrationText.PARTIAL_REJECTED_RESOLVED.default;

    case REGISTRATION_STATUS.REJECTED_RESOLVED:
      if (state === 'AR') {
        return registrationText.PARTIAL_REJECTED_RESOLVED.arkansas;
      }
      return registrationText.PARTIAL_REJECTED_RESOLVED.default;
    
    case REGISTRATION_STATUS.PENDING_EXCHANGE:
      return registrationText.PENDING_EXCHANGE.default;

    default:
      if (isSelfRegistered) {
        return registrationText.UNTRACKED_STATUS.selfRegistered;
      }
      return registrationText.UNTRACKED_STATUS.default;
  }
};
